import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ groups: [], grand_total: 0, count: 0 });
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setCart({ groups: [], grand_total: 0, count: 0 }); return; }
    setLoading(true);
    try {
      const r = await api.get("/cart");
      setCart(r.data);
    } catch (_e) {
      // Silencio intencional: si falla el refresh (offline, no auth), dejamos el cart vacío
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (pubId, qty = 1) => {
    const r = await api.post("/cart/add", { publication_id: pubId, quantity: qty });
    await refresh();
    return r.data;
  };
  const setQuantity = async (pubId, quantity) => {
    const r = await api.patch(`/cart/item/${pubId}`, { quantity });
    await refresh();
    return r.data;
  };
  const remove = async (pubId) => {
    await api.delete(`/cart/item/${pubId}`);
    await refresh();
  };
  const clear = async () => {
    await api.post("/cart/clear");
    await refresh();
  };

  const openDrawer = () => setDrawerOpen(true);
  const closeDrawer = () => setDrawerOpen(false);

  return (
    <CartCtx.Provider value={{ cart, loading, refresh, add, setQuantity, remove, clear, drawerOpen, openDrawer, closeDrawer }}>
      {children}
    </CartCtx.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartCtx);
  if (!ctx) throw new Error("useCart outside provider");
  return ctx;
}
